// mixin for payment form to restore saved form data from local storage
import queryToComponent from "./queryToComponent";

export default {
  mixins: [queryToComponent],

  created() {
    if (this.queryParams["coupon"] === "10off" && localStorage.getItem("saved_form")) {
      try {
        const formData = JSON.parse(localStorage.getItem("saved_form"));
        for (const field of Object.values(formData)) {
          this.paymentForm[field.name] = field.value;
        }
      } finally {
        localStorage.removeItem("saved_form");
      }
    }
  }
};
